function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "instagramIconTitle"
}, "Instagram");

var _ref3 = /*#__PURE__*/React.createElement("desc", {
  id: "instagramIconDesc"
}, "Instagram icon");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M53.37,40.49c0,7.1-5.78,12.88-12.88,12.88H18.4c-7.1,0-12.88-5.78-12.88-12.88V18.4 c0-7.1,5.78-12.88,12.88-12.88h22.08c7.1,0,12.88,5.78,12.88,12.88V40.49L53.37,40.49z M40.49,0H18.4C8.24,0,0,8.24,0,18.4v22.08 c0,10.16,8.24,18.4,18.4,18.4h22.08c10.16,0,18.4-8.24,18.4-18.4V18.4C58.89,8.24,50.65,0,40.49,0L40.49,0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M29.45,38.65c-5.07,0-9.2-4.13-9.2-9.2c0-5.08,4.13-9.2,9.2-9.2s9.2,4.13,9.2,9.2 C38.65,34.52,34.52,38.65,29.45,38.65L29.45,38.65z M29.45,14.72c-8.13,0-14.72,6.59-14.72,14.72s6.59,14.72,14.72,14.72 s14.72-6.59,14.72-14.72S37.58,14.72,29.45,14.72L29.45,14.72z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M45.27,11.66c1.08,0,1.96,0.88,1.96,1.96c0,1.08-0.88,1.96-1.96,1.96c-1.08,0-1.96-0.88-1.96-1.96 C43.31,12.54,44.19,11.66,45.27,11.66L45.27,11.66z"
});

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.89 58.89",
    xmlSpace: "preserve",
    "aria-labelledby": "instagramIconTitle instagramIconDesc",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "instagramIconTitle"
  }, title) : null, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.6231c3be.svg";
export { ForwardRef as ReactComponent };